import { Injectable } from '@angular/core';
import { AuthService } from './auth-service';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthorizationService } from '../../app/authorization.service';
import { AuthRoutingModule } from './auth-routing.module';
import { Router } from '@angular/router';
@Injectable()
export class IdentityGuard implements CanActivate {
    constructor(public authorizationService: AuthorizationService, private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {


        if (window.localStorage.getItem('authorization.service.token_response')) {
            return true
        }
        return false
    }
}



// WEBPACK FOOTER //
// ./src/opc/auth/identity-service.ts